module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-top.94ee9be1.svg";